// biome-ignore lint/correctness/noUnusedImports: required by old tool chain
import React from 'react'
import { view } from 'react-easy-state'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import Footer from './components/Footer'
import Modals from './components/Modals'
import Notifications from './components/Notifications'
import ProtectedRoute from './components/ProtectedRoute'
import ScrollToTop from './components/ScrollToTop'
import Admin, { routes } from './containers/Admin'
import Book from './containers/Book'
import ConfirmReservation from './containers/ConfirmReservation'
import ErrorBoundary from './containers/ErrorBoundary'
import Login from './containers/Login'
import NotFound from './containers/NotFound'
import RidingSchool from './containers/RidingSchool'
import Start from './containers/Start'
import state from './state'

const App = () => (
  <ErrorBoundary>
    <div
      className="text-gray-800"
      id="app"
      style={{
        filter: state.semaphore > 0 ? 'grayscale(1) brightness(0.9)' : 'none',
        pointerEvents: state.semaphore > 0 ? 'none' : 'auto',
        transition: 'filter 0.2s ease-in 0.5s'
      }}
    >
      <Router>
        <ScrollToTop>
          <Switch>
            {routes.map(({ path }) => (
              <ProtectedRoute component={Admin} exact key={path} path={path} />
            ))}
            <Route component={Book} exact path="/book/:id" />
            <Route
              component={ConfirmReservation}
              exact
              path="/confirm-reservation/:hash"
            />
            <Route component={Login} exact path="/login" />
            <Route component={RidingSchool} exact path="/reitschule" />
            <Route component={Start} exact path="/" />
            <Route component={NotFound} />
          </Switch>
        </ScrollToTop>
        <Footer />
      </Router>
    </div>
    <Modals />
    <Notifications />
  </ErrorBoundary>
)

export default view(App)
